/* eslint-disable no-template-curly-in-string */
import * as cheerio from "cheerio";

import axios from "axios";

import { searchProductInRetailer_FrontEnd } from "pricePinger-shared/dist/product_search";
import {
  productSaveDataToWPservices,
  serviceGetCustomizedTitleParams,
} from "src/api/service/services";

// Generic function to parse retailer products
export async function parseFrontEnd(
  //config: any,
  config_ret: any,
  productTitle: string
) {
  try {
    const customizedTitleParams = serviceGetCustomizedTitleParams();

    const productData = await searchProductInRetailer_FrontEnd(
      config_ret,
      productTitle,
      //  $,
      customizedTitleParams,
      axios,
      cheerio
    );

    // Save parsed data to DB if available
    if (
      productData &&
      productData.retailer_product_id !== null &&
      productData.title !== null &&
      productData.retailer !== null
    ) {
      try {
        await productSaveDataToWPservices(productData); // Assuming productSaveServices is a function that saves data to the database
      } catch (dbError) {
        console.error(
          `Failed to save data for URL: ${config_ret.base_url}`,
          dbError
        );
      }
    }
  } catch (error) {
    console.error(
      `Error fetching product details from ${config_ret.base_url}:`,
      error
    );
  }
}
